import axios from 'axios';
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import { clearSession, session } from '../utils/AuthSession';
var qs = require('qs');


export const Api = async (params,pub=true) => {

    let Token, EncryptedCookie, response
	const currentSession = session()
	const requestTimeout = Number(params.timeout || process.env.REACT_APP_REQUEST_TIMEOUT)

	const config = {
		baseURL: (pub)?(process.env.REACT_APP_CORE_LOYALTY_SYSTEM):(process.env.REACT_APP_BASE_URL),
		timeout: Number.isFinite(requestTimeout) && requestTimeout > 0 ? requestTimeout : undefined,
	}
    // return session().token.token
	if(params.access==='auth' && currentSession){
		config.headers = {'Authorization': `${currentSession.type} ${currentSession.token}`}
	}

	try {
		switch (params.method) {
			case 'get':
				response =  await axios.get(params.url+'?'+qs.stringify(params.reqBody),config)
				break;
			case 'post':
				response =  await axios.post(params.url,params.reqBody,config)
				break;
			case 'put':
				config.data = params.reqBody;
				response =  await axios.put(params.url,params.reqBody,config)
				break;
			case 'delete':
				config.data = params.reqBody;
				response =  await axios.delete(config.baseURL+params.url,config)
				break;
			default:
				break;
		}

		return response.data

	} catch (error) {
		if (params.access === 'auth' && [401, 403].includes(Number(error?.response?.status))) {
			clearSession()
		}
		// Selalu kembalikan bentuk konsisten agar caller tidak crash saat response undefined
		if(error?.response?.data){
			return error.response.data
		}
		const isTimeout = error?.code === 'ECONNABORTED' || `${error?.message || ''}`.toLowerCase().includes('timeout')
		return {
			status: false,
			message: error?.message || 'Request failed',
			code: error?.code || null,
			isTimeout,
			data: null
		}
	}
}
